import { ReplaySubject } from 'rx';
import eventBus from '../lib/event-bus-rx';
import {logError} from './Logging';
import {getTokenRacerId} from '../utils/isLoggedIn';

let _data = {};

function streamHook(id, initial) {

  if (_data[id] === void 0) {
    const subject = new ReplaySubject(1);
    typeof initial === 'undefined' || subject.onNext(initial);
    eventBus.getTopic(id).subscribe((msg) => subject.onNext(msg));
    _data[id] = subject;
  }

  return _data[id];
}

function streamFail(id, stream, fromPredicate) {
  const failed = (error) => {

    eventBus.publish(id, {
      error
    });

    logError(
      getTokenRacerId(),
      window.location.href,
      `streamFail-${id}-${error}`,
      {
        browserName: bowser.name,
        browserVersion: bowser.version,
        osName: bowser.osname,
        osVersion: bowser.osversion
      }
    );
  };

  return stream.subscribe((msg) => {
    const result = fromPredicate(msg);
    if (result) {
      eventBus.publish(id, result);
    }
    else {
      failed(msg);
    }
  }, failed);
}

export {
  streamFail,
  streamHook,
  eventBus
}



/** WEBPACK FOOTER **
 ** ./data/Streams.js
 **/